import { createRouter,createWebHashHistory } from 'vue-router'
import i18n from "../../lang"
const t = i18n.global.t
const Dashboard = () => import('../pages/Dashboard.vue')
const Logs = () =>  import('../pages/Logs.vue')
// const Invitation = () => import('../pages/Invitation.vue')
const Enterprise = () => import('../pages/Enterprise.vue')
const Orders = () => import('../pages/Orders.vue')
const OrderDetail = () => import('../pages/OrderDetail.vue')
const Payment = () => import('../pages/Payment.vue')
// const Devices = () => import('../pages/Devices.vue')
const SubmitOrder = () => import('../pages/SubmitOrder.vue')
const PaymentSuccess = () => import('../pages/PaymentSuccess.vue')
export const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title: 'title.team',
      icon: 'sidebar-dashboard-icon'
    }
  },
  // {
  //   path: '/invitation',
  //   name: 'invitation',
  //   component: Invitation,
  //   meta: {
  //     title: '招待状の管理',
  //     icon: 'sidebar-invitation-icon'
  //   }
  // },
  {
    path: '/enterprise',
    name: 'enterprise',
    component: Enterprise,
    meta: {
      title: 'title.company',
      icon: 'sidebar-enterprise-icon'
    }
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders,
    meta: {
      title: 'title.order',
      icon: 'sidebar-order-icon'
    }
  },
  {
    path: '/orders/detail/:id',
    name: 'order_detail',
    component: OrderDetail,
    meta: {
      title: 'title.orderInfo',
    }
  },
  {
    path: '/logs',
    name: 'logs',
    component: Logs,
    meta: {
      title: 'title.log',
      icon: 'sidebar-logs-icon'
    }
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment,
    meta: {
      title: 'title.buy',
    }
  },
  {
    path: '/submit_order',
    name: 'submit_order',
    component: SubmitOrder,
    meta: {
      title: 'title.pay',
    }
  },
  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    meta: {
      title: 'title.paySuccess'
    }
  },
  // {
  //   path: '/devices',
  //   name: 'devices',
  //   component: Devices,
  //   meta: {
  //     title: '支払方法',
  //   }
  // }
]
const router = createRouter({
  history: createWebHashHistory('/admin.html'),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = t(to.meta.title)
  next()
})
export default router
